import "./about.css";
import React, { useState, useEffect, Component } from "react";
import Footer from "./footer";
import Video from "../images/leadway video.mp4";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import mission from "../images/mission.png";
import vision from "../images/vision.png";
import principle from "../images/principle.png";
import integrity from "../images/Integrity.png";
import innovation from "../images/Innovation.png";
import customer from "../images/Customer focus.png";
import proffesionalism from "../images/proffesionalism.png";
import men from "../images/men.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import prestige from "../images/prestige.png";
import mbc from "../images/mbc.png";
import leadway from "../images/leadway car.png";
import OrngArr from "../images/org-arr.png";
import Uba from "../images/uba.png";
import Zenith from "../images/zenith.png";
import Firstbank from "../images/first bank.png";
import Mobilemen from "../images/mobile-men.png";
import "swiper/css/navigation";
import AOS from 'aos';

import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";

const client = new ApolloClient({
  link: new HttpLink({
    uri: "https://pensure-cms.inspireleadership.biz/graphql",
  }),
  cache: new InMemoryCache(),
});

const AboutUs = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };


  

  const [heroBanner, setHeroBanner] = useState([]);
  const [heroMobile, setHeroMobile] = useState([]);
  const [productText, setProductText] = useState("");
  const [productTextContd, setProductTextContd] = useState("");
  const [productInfo, setProductInfo] = useState([]);
  const [productInfo1, setProductInfo1] = useState([]);
  const [listSections, setListSections] = useState([]);
  const [listSections1, setListSections1] = useState([]);
  const [custodian1, setCustodian1] = useState("");
  const [custodian2, setCustodian2] = useState("");
  const [custodian3, setCustodian3] = useState("");

  window.scrollTo(0, 0);

  useEffect(() => {
  
     AOS.init({
      offset: 0,
      duration: 1000,
      once: true
    });
  
      
  }, [])


  useEffect(() => {
    client
      .query({
        query: gql`
          query NewQuery {
            pages {
              edges {
                node {
                  aboutUs {
                    productText
                    productTextContd
                    hero {
                      buttonLink
                      buttonName
                      caption
                      heading
                      image
                    }
                    heromobile {
                      buttonLink
                      buttonName
                      fieldGroupName
                      heading
                      image
                    }
                    listSection {
                      heading
                      image {
                        mediaItemUrl
                      }
                      list {
                        items
                        icon {
                          mediaItemUrl
                        }
                      }
                      caption
                    }
                    listSection1 {
                      heading
                      caption
                      list {
                        items
                      }
                    }
                    productInfo {
                      explanation
                      heading
                      icon {
                        mediaItemUrl
                      }
                    }
                    productInfo1 {
                      explanation
                      heading
                      icon {
                        mediaItemUrl
                      }
                      link
                    }
                    custodian1 {
                      mediaItemUrl
                    }
                    custodian2 {
                      mediaItemUrl
                    }
                    custodian3 {
                      mediaItemUrl
                    }
                  }
                }
              }
            }
          }
        `,
      })
      .then((result) => {
        console.log(result);

        setHeroBanner(result.data.pages.edges[5].node.aboutUs.hero);
        setHeroMobile(result.data.pages.edges[5].node.aboutUs.heromobile);
        setProductText(result.data.pages.edges[5].node.aboutUs.productText);
        setProductTextContd(
          result.data.pages.edges[5].node.aboutUs.productTextContd,
        );
        setProductInfo(result.data.pages.edges[5].node.aboutUs.productInfo);
        setProductInfo1(result.data.pages.edges[5].node.aboutUs.productInfo1);
        setListSections(result.data.pages.edges[5].node.aboutUs.listSection);
        setListSections1(result.data.pages.edges[5].node.aboutUs.listSection1);
        setCustodian1(
          result.data.pages.edges[5].node.aboutUs.custodian1.mediaItemUrl,
        );
        setCustodian2(
          result.data.pages.edges[5].node.aboutUs.custodian2.mediaItemUrl,
        );
        setCustodian3(
          result.data.pages.edges[5].node.aboutUs.custodian3.mediaItemUrl,
        );
      });
  }, []);

  let listSectionsDisplay;
  let listSectionsDisplay1;
  let productInfoDisplay;
  let productInfoDisplay1;
  let heroBannerDisplay;
  let heroMobileBannerDisplay;

  if (heroBanner.length > 0) {
    heroBannerDisplay = heroBanner.map((banner, i) => (
      <div className="about-us-video-section">
        <video className="about-us-video" autoPlay loop muted>
          <source src={banner.image} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="about-us-content">
          <div id="abt-text-mobile" className="abt-text ">
            <h1 className="lead-h1 " data-aos="zoom-in" data-aos-delay="200" >{banner.heading}</h1>
            <p className="grey-p" data-aos="fade-up" data-aos-delay="200" >{banner.caption}</p>
            <a
              className="btn-trns"
              href={banner.buttonLink}
              data-target="_blank"
          data-aos="fade-up" data-aos-delay="200"   >
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (heroMobile.length > 0) {
    heroMobileBannerDisplay = heroBanner.map((banner, i) => (
      <div className="about-us-video-section">
        <video className="about-us-video" autoPlay loop muted>
          <source src={banner.image} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="about-us-content">
          <div id="abt-text-mobile" className="abt-text ">
            <h1 className="lead-h1 "  data-aos="zoom-in" data-aos-delay="200">{banner.heading}</h1>
            <p className="grey-p"  data-aos="fade-up" data-aos-delay="200">{banner.caption}</p>
            <a
              className="btn-trns"
              href={banner.buttonLink}
              data-target="_blank"
             data-aos="fade-up" data-aos-delay="200">
              {" "}
              {banner.buttonName}{" "}
              <FontAwesomeIcon icon={faArrowRight} className="grey-arrw" />
            </a>
          </div>
        </div>
      </div>
    ));
  }

  if (productInfo.length > 0) {
    productInfoDisplay = productInfo.map((info, i) =>
      i < 2 ? (
        <div className="card statements-crd mb-4 mt-5"  data-aos="fade-up" data-aos-delay="200">
          <div className="">
            <img className="pb-4" src={info.icon.mediaItemUrl} />
            <h4 className="card-subtitle mb-2 statement-hdr">{info.heading}</h4>
            <p className="card-text pt-3 grey-p" style={{ fontSize: "16px" }}>
              {info.explanation}
            </p>
          </div>
        </div>
      ) : (
        <div className="card statements-crd statements-crd-full"  data-aos="fade-up" data-aos-delay="200">
          <div id="vision-mbl" className="d-flex align-items-start ">
            <img className="pb-4" src={info.icon.mediaItemUrl} />
            <div className="ps-4">
              <h4 className="card-subtitle mb-2 statement-hdr">
                {info.heading}
              </h4>
              <p className="card-text pt-3 grey-p" style={{ fontSize: "16px" }}>
                {info.explanation}
              </p>
            </div>
          </div>
        </div>
      ),
    );
  }

  if (productInfo1.length > 0) {
    productInfoDisplay1 = productInfo1.map((info, i) => (
      <div className="slider-item slider-1" >
        <img className="mb-4" src={info.icon.mediaItemUrl}  data-aos="fade-up" data-aos-delay="200" />
        <h4 className="h4 mb-4"  data-aos="fade-up" data-aos-delay="200"> {info.heading} </h4>
        <p className="grey-p mb-4" style={{ fontSize: "16px" }}  data-aos="fade-up" data-aos-delay="200">
          {info.explanation}
        </p>
        <a
          href={info.link}
          className="d-flex align-items-center orng-link "
          datat-target="_blank"
          data-aos="fade-up" data-aos-delay="200">
          Visit {info.heading}
          <img className="ms-2" src={OrngArr} />
        </a>
      </div>
    ));
  }

  if (listSections.length > 0) {
    listSectionsDisplay = listSections.map((section, i) =>
      i % 2 ? (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5"
        >
          <div className="pension-div1 pb-2">
            <h3 className="rma-h3 pb-2"  data-aos="fade-up" data-aos-delay="200"> {section.heading} </h3>

            <p
              className="grey-p-pms pb-2"
              style={{ color: "#3B475A", width: "470px" }}
             data-aos="fade-up" data-aos-delay="200">
              {section.caption}
            </p>

            <ul
              className="pt-2 custom-square"
              style={{ listStyleType: "square" }}
            >
              {section.list.map((items, i) => (
                <li className="pb-3 pt-3 d-flex align-items-center btm-bdr" data-aos="fade-up" data-aos-delay="200">
                  <span className="bckground">
                    <img className="" src={items.icon.mediaItemUrl} />
                  </span>

                  <h6 className="h6 ps-3"> {items.items} </h6>
                </li>
              ))}
            </ul>
          </div>

          <div className="d-flex justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ) : (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5"
        >
          <div className="pension-div1 pb-2">
            <h3 className="rma-h3 pb-2" data-aos="fade-up" data-aos-delay="200"> {section.heading} </h3>

            <p
              className="grey-p-pms  pb-2"
              style={{ color: "#3B475A", width: "470px" }}
             data-aos="fade-up" data-aos-delay="200">
              {section.caption}
            </p>

            <ul
              className="pt-2 custom-square"
              style={{ listStyleType: "square" }}
            >
              {section.list.map((items, i) => (
                <li className="pb-3 pt-3 d-flex align-items-center btm-bdr" data-aos="fade-up" data-aos-delay="200">
                  <span className="bckground">
                    <img className="" src={items.icon.mediaItemUrl} />
                  </span>

                  <h6 className="h6 ps-3"> {items.items} </h6>
                </li>
              ))}
            </ul>
          </div>

          <div className="d-flex justify-content-end">
            <img className="img-fluid" src={section.image.mediaItemUrl} />
          </div>
        </div>
      ),
    );
  }

  if (listSections1.length > 0) {
    listSectionsDisplay1 = listSections1.map((section, i) => (
      <div
        id="mobile-view"
        className=" d-flex align-items-center justify-content-between padding-section-standard-top pb-5"
      >
        <div className="pb-2">
          <h3 className="rma-h3 pb-5=2" data-aos="fade-up" data-aos-delay="200"> {section.heading} </h3>

          <p
            className="grey-p-pms  pb-2 "
            style={{ color: "#3B475A", width: "470px" }}
         data-aos="fade-up" data-aos-delay="200" >
            {section.caption}
          </p>

          <hr
            className="btm-bdr"
            style={{ borderTop: "none", width: "600px" }}
          />

          <ul
            className="pt-2 ps-3 custom-square"
            style={{ listStyleType: "square", paddingLeft: "20px" }}
          >
            {section.list.map((items, i) => (
              <li className="grey-p-rma pb-4" style={{ color: "#3B475A" }} data-aos="fade-up" data-aos-delay="200">
                {items.items}
              </li>
            ))}
          </ul>
        </div>
      </div>
    ));
  }

  return (
    <>
    <div className="about-us-container ">
      <div className="d-none d-sm-block"  >{heroBannerDisplay}</div>

      <div className="d-block d-sm-none">{heroMobileBannerDisplay}</div>

      <div className="containeer">
        <div id="mobile-view" className="d-flex justify-space-between pt-5">
          <div className=" width-fifty">
            <h2 className="lead-h2 " data-aos="fade-in" data-aos-delay="200" >Our Story </h2>
          </div>
          <div className=" width-fifty abt-para">
            <p className="grey-p grey-color" data-aos="fade-up" data-aos-delay="200" >{productText}</p>

            <p className="pt-3 grey-p grey-color" data-aos="fade-up" data-aos-delay="200" >{productTextContd}</p>
          </div>
        </div>
        <div
          id="mobile-view"
          className=" d-flex justify-content-between pt-5 pb-5 "
        >
          <div className="">
            <div className="card experience-crd">
              <div className=" d-flex flex-column gap-3 crd-bdy">
                <div className="d-flex align-items-center">
                  <span className="full-stop">•</span>
                  <p className="grey-p grey-color ms-2"> Years of Experience</p>
                </div>

                <hr className="crd-hr" />
                <p className="crd-hd">18+</p>
                <p className="grey-p grey-color ">
                  Delivering trusted pension services since 2004
                </p>
              </div>
            </div>
          </div>
          <div className="">
            <div className="card experience-crd">
              <div className=" d-flex flex-column gap-3 crd-bdy">
                <div className="d-flex">
                  <span className="full-stop">•</span>
                  <p className="grey-p grey-color ms-2">Shareholder Capital</p>
                </div>

                <hr className="crd-hr" />
                <p className="crd-hd">₦2.0B</p>
                <p className="grey-p grey-color ">
                  One of the most capitalized PFAs in Nigeria
                </p>
              </div>
            </div>
          </div>
          <div className="">
            <div className="card experience-crd">
              <div className=" d-flex flex-column gap-3 crd-bdy">
                <div className="d-flex align-items-center">
                  <span className="full-stop">•</span>
                  <p className="grey-p grey-color ms-2"> Shareholders' Fund</p>
                </div>

                <hr className="crd-hr" />
                <p className="crd-hd">₦10.0B+</p>
                <p className="grey-p grey-color ">
                  Built on strength, unimpaired by losses
                </p>
              </div>
            </div>
          </div>
          <div className="">
            <div className="card experience-crd">
              <div className=" d-flex flex-column gap-3 crd-bdy">
                <div className="d-flex align-items-center">
                  <span className="full-stop">•</span>
                  <p className="grey-p grey-color ms-2"> Expertise Combined</p>
                </div>

                <hr className="crd-hr" />
                <p className="crd-hd">125+ yrs</p>
                <p className="grey-p grey-color ">
                  Across fund management, insurance & finance
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className=" ">
          <div
            id="mobile-view"
            className="d-flex flex-wrap justify-content-between"
          >
            {productInfoDisplay}
          </div>

          {listSectionsDisplay}
        </div>
      </div>
      <div className="  cont">
        <div
          id="mobile-view"
          className="containeer  d-flex justify-content-between "
        >
          <div className="slider-divv-head">
            <p className="orange-p">OUR BENEFITS</p>
            <h2 className="lead-h2" style={{ color: "#FFFFFF" }}>
              Our Shareholders
            </h2>
          </div>
          <div className=" slider-divv">
            <Slider {...settings}>{productInfoDisplay1}</Slider>
          </div>
        </div>
      </div>
      <div className=" d-flex justify-content-between  pension containeer">
        {listSectionsDisplay1}

        <div className="mt mb d-flex justify-content-between align-items-center flex-column ">
          <div
            id="mobile-view"
            className="gp w-100 d-flex justify-content-center align-items-center gap-5 "
          >
            {" "}
            <div className="img-bg " data-aos="zoom-in" data-aos-delay="200">
              <img src={custodian2} />
            </div>
            <div className="img-bg" data-aos="zoom-in" data-aos-delay="200">
              <img className="zenith" src={custodian1} />{" "}
            </div>
          </div>
          <div className=" img-bg zenith  mt-4 justify-content-center d-flex" data-aos="zoom-in" data-aos-delay="200">
            <img src={custodian3} />{" "}
          </div>
        </div>
      </div>
      
    </div>

        <Footer/>
     <div className='height'> 

              </div>
    </>

  );
};

export default AboutUs;
